import styled from '@mui/material/styles/styled'

export const Value = styled('div')(({ theme }) => ({
  fontFamily: 'Source Sans Pro',
  color: theme.palette.common.black,
  fontSize: '14px',
}))
